import { useMemo } from "react";

type GroupQueryResult = { id: string; name: string };
export type AvailableGroup = { id: string; name: string; active: boolean };

export function useAvailableGroups(groupQueryResults: GroupQueryResult[], activeGroupIds: string[]): AvailableGroup[] {
  return useMemo(
    () =>
      groupQueryResults.map((g) => ({
        id: g.id,
        name: g.name,
        active: activeGroupIds.includes(g.id),
      })),
    [groupQueryResults, activeGroupIds],
  );
}
